module.exports = __webpack_public_path__ + "static/media/crease.0e32ebb9.png";